/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

/** Utilities */
import { decryptUrlData } from "../../../../services/CryptoService";
import formatDate from "../../../../lib/formatDate";

/** Common Components */
import TaskCard from "../../../../components/board/TaskCard";
import ViewToggle from "../../../../components/ui/viewToggle/ViewToggle";
import NoDataFound from "../../../../components/ui/noDataFound/NoDataFound";
import DropdownSelect from "../../../../components/finalForms/ui/inputs/dropdown/DropdownSelect";

/** Common Services & Data Files */
import { groupByOptions } from "../../../taskboard/Task.data";
import Toolbar from "../../../../components/tasklayout/toolbar/Toolbar";
import { normalizeTaskGridRows } from "../../../../components/tasks/adapters/normalizeTaskGridRow";
import { getCardInfo } from "../../../../lib/getCardInfo";

/** RTK Query */
import {
  useGetAllTaskByTeamPlanningIdMutation,
  useLazyGetAllStatusByTeamIdQuery,
  useLazyGetTeamPlanningIdByTeamIdQuery,
} from "../../../../app/services/teamboardAPI";
import { useGetPlanningListByUserIdAndProjectIdMutation } from "../../../../app/services/teamPlanningAPI";
import { useGetAllTeamProjectListMutation } from "../../../../app/services/teamProjectsAPI";

import TaskBoard from "../../../../components/board/TaskBoard";

const TeamBoard = () => {

  const { user } = useSelector((state) => state.auth);
  const { id } = useParams();
  let teamId = null;
  let teamName = "";

  const teamIdData = id ? decryptUrlData(id) : 0;
  if (typeof teamIdData === "object" && teamIdData !== null) {
    teamId = teamIdData.teamId;
    teamName = teamIdData.teamName;

  } else if (teamIdData) {
    teamId = teamIdData;
  }

  const [taskData, setTaskList] = useState([]);
  const [planningdata, setPlanningData] = useState([]);
  const [projectData, setprojectData] = useState([]);

  const [boardColumns, setTaskStatus] = useState([]);
  const [viewType, setViewType] = useState("list");
  const [selectedProject, setSelectedProject] = useState();
  const [selectedPlanning, setSelectedPlanning] = useState();
  const [planningList, setplanningList] = useState([]);

  const [
    getTeamPlanningIdByTeamId,
    {
      data: TeamPlanningData,
    },
  ] = useLazyGetTeamPlanningIdByTeamIdQuery();

  const [
    getAllTeamProjectList,
    {
      isSuccess: isTeamProjectListSuccess,
      data: isTeamProjectListData,
    },
  ] = useGetAllTeamProjectListMutation();

  const [
    getAllTaskByTeamPlanningId,
    {
      isFetching: isTaskByTeamPlanningIdFetching,
      isSuccess: isTaskByTeamPlanningId,
      data: TaskByTeamPlanningIddata,
    },
  ] = useGetAllTaskByTeamPlanningIdMutation();

  const [
    getAllStatusByTeamId,
    {
      isFetching: isStatusByTeamIdFetching,
      isSuccess: isStatusByTeamId,
      data: StatusByTeamIddata,
    },
  ] = useLazyGetAllStatusByTeamIdQuery();

  const [getPlanningListByUserIdAndProjectId, {
    isFetching: isgetTeamPlanningListByUserIdfetching,
    isSuccess: isgetTeamPlanningListByUserIdsuccess,
    data: isgetTeamPlanningListByUserIdData,

  },] = useGetPlanningListByUserIdAndProjectIdMutation();
  const showListView = () => setViewType("list");
  const showCardView = () => setViewType("card");

  const getTeamPlanningDataList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 10,
      },
      filters: {
        searchText: "",
      },
      teamId: teamId,
    };
    getAllTeamProjectList(request);
  };

  useEffect(() => {
    if (teamId) {
      getTeamPlanningIdByTeamId(teamId);
      getAllStatusByTeamId(teamId);
      getTeamPlanningDataList();
      const request = {
        userId: user.userId
      }
      getPlanningListByUserIdAndProjectId(request)
    }
  }, [teamId]);


  useEffect(() => {
    if (
      isgetTeamPlanningListByUserIdsuccess &&
      !isgetTeamPlanningListByUserIdfetching &&
      isgetTeamPlanningListByUserIdData
    ) {
      const teamPlanningIdData = isgetTeamPlanningListByUserIdData.filter((i) => i.teamId === teamId);
      const planningListData = teamPlanningIdData?.map((item) => ({
        value: item.teamPlanningId,
        label: `${formatDate(item.startDate, "DD/MM/yyyy")} - ${formatDate(item.endDate, "DD/MM/yyyy")}`,
        startDate: item.startDate,
        endDate: item.endDate
      }));
      setplanningList(planningListData);
      const today = new Date();
      const todayPlanning = planningListData.find((item) => {
        const start = new Date(item.startDate);
        const end = new Date(item.endDate);
        return today >= start && today <= end;
      });

      if (todayPlanning) {
        setSelectedPlanning(todayPlanning);
        getAllTaskByTeamPlanningId({ teamPlanningId: todayPlanning.value });
      }
    }
  }, [isgetTeamPlanningListByUserIdsuccess, isgetTeamPlanningListByUserIdfetching])

  useEffect(() => {
    if (TeamPlanningData && typeof TeamPlanningData === "object") {
      const dropdownPlanningData = [
        {
          value: TeamPlanningData.teamPlanningId,
          label: `${formatDate(TeamPlanningData.startDate, "DD MMM, YYYY")} - ${formatDate(TeamPlanningData.endDate, "DD MMM, YYYY")}`,
        },
      ];
      setPlanningData(dropdownPlanningData);
    }
  }, [TeamPlanningData]);

  useEffect(() => {
    if (!isTaskByTeamPlanningIdFetching && isTaskByTeamPlanningId && TaskByTeamPlanningIddata) {
      let filteredData = TaskByTeamPlanningIddata;
      if (selectedPlanning && selectedPlanning.value) {
        filteredData = filteredData.filter(
          (task) => task.teamPlanningId === selectedPlanning.value
        );
      }
      if (selectedProject && selectedProject.value) {
        filteredData = filteredData.filter(
          (task) => task.projectId === selectedProject.value
        );
      }
      setTaskList(normalizeTaskGridRows(filteredData));
    }
  }, [
    isTaskByTeamPlanningIdFetching,
    isTaskByTeamPlanningId,
    TaskByTeamPlanningIddata,
    selectedPlanning,
    selectedProject,
  ]);

  useEffect(() => {
    if (!isStatusByTeamIdFetching && isStatusByTeamId && StatusByTeamIddata) {
      const status = StatusByTeamIddata.map((item) => ({
        value: item.taskStatusId,
        label: item.statusName,
      }));
      setTaskStatus(status);
    }
  }, [isStatusByTeamIdFetching, isStatusByTeamId, StatusByTeamIddata]);

  const onItemMove = (task, newGroup) => { };
  useEffect(() => {
    if (isTeamProjectListSuccess && isTeamProjectListData) {
      if (isTeamProjectListData) {
        const dropdownData = isTeamProjectListData.dataSource.map((item) => ({
          value: item.projectId,
          label: item.projectName,
        }));
        setprojectData(dropdownData);
      }
    }
  }, [isTeamProjectListSuccess, isTeamProjectListData]);

  const handleRefreshGrid = () => {
    if (!TaskByTeamPlanningIddata) return;

    let filteredData = TaskByTeamPlanningIddata;

    if (selectedPlanning && selectedPlanning.value) {
      filteredData = filteredData.filter(
        (task) => task.teamPlanningId === selectedPlanning.value
      );
    }

    if (selectedProject && selectedProject.value) {
      filteredData = filteredData.filter(
        (task) => task.projectId === selectedProject.value
      );
    }

    setTaskList(normalizeTaskGridRows(filteredData));
  };

  const handalDropDownChange = (selectedOption, type) => {
    if (type === "planning") {
      setSelectedPlanning(selectedOption);
      getAllTaskByTeamPlanningId({ teamPlanningId: selectedOption.value });
    }
    else if (type === "project") {
      setSelectedProject(selectedOption);
      const request = {
        userId: user.userId
      }
      getPlanningListByUserIdAndProjectId(request)
    }
  }

  const cardData = [
    { key: "Team", value: teamName },
    // { key: "Planning", value: formatDate(planningData.startDate, "DD MMM, YYYY") + " - " + formatDate(planningData.endDate, "DD MMM, YYYY") },
  ];

  return (
    <div className="main-task-board-section">
      <div className="taskboard-filter">
        <div className="task-grid-dropdown">
          {cardData ? getCardInfo(cardData) : null}
        </div>
        <div className="d-flex ">

          <div className="team-planning-dropdown w-100 mr-2">
            <DropdownSelect
              value={selectedProject}
              optionsValue={projectData}
              placeholder={"Select Project"}
              handleDropdownChange={(option) => handalDropDownChange(option, "project")}
            />
          </div>
          <div className="team-planning-dropdown w-100 mr-5">
            <DropdownSelect
              value={selectedPlanning}
              optionsValue={planningList}
              placeholder={"Select Planing"}
              handleDropdownChange={(option) => handalDropDownChange(option, "planning")}
            />

          </div>
          <ViewToggle
            onListViewClick={showListView}
            onCardViewClick={showCardView}
            viewType={viewType}
          ></ViewToggle>
        </div>
      </div>
      <div className="taskboard-body">
        {taskData &&
          taskData.length > 0 ?
          (viewType === "card" ? (
            <TaskBoard
              data={taskData}
              groupByField="statusName"
              columns={boardColumns}
              groupByOptions={groupByOptions}
              renderItem={(item) => <TaskCard task={item} />}
              onItemMove={(movedItem, newGroup) =>
                onItemMove(movedItem, newGroup)
              }
            />

          ) : (
            <Toolbar
              listOnly
              projectId={selectedProject?.value || taskData[0]?.projectId || 0}
              taskListData={taskData}
              isTeamPlanning={false}
              allowEditStatus={Boolean(selectedProject?.value || taskData[0]?.projectId)}
              allowEditAssignee={Boolean(selectedProject?.value || taskData[0]?.projectId)}
              isShowActualTime={false}
              isShowRemainingTime={true}
              isDataLoading={false}
              onRefreshGrid={handleRefreshGrid}
            />
          ))
          :
          <NoDataFound />}
      </div>
    </div>
  );
};
export default TeamBoard;
